<template>
  <DataList
    title="Співробітники"
    resource="crm-employees"
    :columns="columns"
    :get-items-fn="getEmployees"
    :search-label="'Пошук за ПІБ'"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as employeesApi from "../../backend/employeesApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "ПІБ", name: "title" },
      { title: "Email", name: "email" },
    ],
  }),
  methods: {
    async getEmployees(...args) {
      return await employeesApi.getEmployees(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
